<template>
  <footer class="footer">
    <div class="footer-content">      
      <div class="footer-links">
        <div class="footer-section">
          <h3>Produtos</h3>
          <ul>
            <li><a href="https://www.logcomex.com/">NCM Intel</a></li>
            <li><a href="https://www.logcomex.com/solucoes/shipment-intel">Shipment Intel</a></li>
            <li><a href="https://conteudo.logcomex.com/log-os">LogOS</a></li>
            <li><a href="https://www.logcomex.com/solucoes/logmanager">LogManager</a></li>
            <li><a href="https://www.logcomex.com/solucoes/logautomation-3">LogAutomation</a></li>
            <li><a href="https://www.logcomex.com/solucoes/export-intel">Export Intel</a></li>
            <li><a href="https://conteudo.logcomex.com/import-mexico">Import Mexico</a></li>
            <li><a href="https://conteudo.logcomex.com/finance-suite">Finance Suite</a></li>
            <li><a href="https://conteudo.logcomex.com/catalogo-de-produtos">Catálogo de produtos</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h3>Recursos</h3>
          <ul>
            <li><a href="https://ncm.logcomex.com/">Consulta NCM</a></li>
            <li><a href="https://logtools.logcomex.io/tools">LogTools</a></li>
            <li><a href="https://conteudo.logcomex.com/logcomex-academy">Logcomex Academy</a></li>
            <li><a href="https://www.logcomex.com/cases-de-sucesso">Cases de Sucesso</a></li>
            <li><a href="https://blog.logcomex.com/">Blog</a></li>
            <li><a href="https://insights.logcomex.com/">Insights</a></li>
            <li><a href="https://www.logcomex.com/conteudo-gratuito">Conteúdos Gratuitos</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h3>Links Úteis</h3>
          <ul>
            <li><a href="https://www.logcomex.com/sobre-nos">Sobre a Logcomex</a></li>
            <li><a href="https://www.logcomex.com/carreiras">Trabalhe na Logcomex</a></li>
            <li><a href="https://www.logcomex.com/contato">Contato</a></li>
            <li><a href="https://www.logcomex.com/imprensa">Imprensa</a></li>
            <li><a href="https://www.logcomex.com/termos">Termos</a></li>
            <li><a href="https://cdn.prod.website-files.com/5e7b99a162211f50391ae211/6748605bad18bbde54b5be0a_transparency%20FAQ_A4_V3.pdf">Transparency FAQ</a></li>
            <li><a href="https://cdn.prod.website-files.com/5e7b99a162211f50391ae211/67acdbc1d2fd33776b9e0de8_CoI%CC%80%C2%81digo%20de%20EI%CC%80%C2%81tica%20e%20Conduta_2025.pdf">Código de Ética e Conduta</a></li>
          </ul>
        </div>

        <div class="footer-section certifications">
          <img src="@/assets/images/gptw.svg" alt="Great Place to Work" class="certification-badge gptw" />
          <img src="@/assets/images/endeavor.png" alt="Endeavor" class="certification-badge endeavor" />
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <img src="@/assets/images/logcomex-logo.svg" alt="Logcomex" class="footer-logo" />
          
          <div class="social-links">
            <a href="https://www.facebook.com/logcomex" target="_blank" rel="noopener" class="social-link">
              <font-awesome-icon :icon="['fab', 'facebook']" />
            </a>
            <a href="https://www.linkedin.com/company/logcomex/" target="_blank" rel="noopener" class="social-link">
              <font-awesome-icon :icon="['fab', 'linkedin']" />
            </a>
            <a href="https://www.instagram.com/logcomex/" target="_blank" rel="noopener" class="social-link">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
            <a href="https://www.youtube.com/c/Logcomex" target="_blank" rel="noopener" class="social-link">
              <font-awesome-icon :icon="['fab', 'youtube']" />
            </a>
          </div>
        </div>

        <p class="address">
          Logcomex LTDA | CNPJ: 13.475.043/0001-75 | Av. Cândido de Abreu, 70 - Torre B - 1º andar - Centro Cívico, Curitiba - PR - Brasil | +55 4003-3317
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer {
  background-color: #fff;
  padding: 26px 24px;
  color: #666;
  border-top: 1px solid #eee;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  margin-bottom: 10px;
}

.footer-section h3 {
  color: #7C3AED;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  font-family: 'Poppins', sans-serif;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin-bottom: 2px;
}

.footer-section ul li a {
  color: #0A2540;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;
  font-family: 'Inter', sans-serif;
  line-height: 1.5;
}

.footer-section ul li a:hover {
  color: #7C3AED;
}

.certifications {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: flex-start;
}

.certification-badge {
  width: auto;
}

.certification-badge.gptw {
  width: auto;
  height: 120px;
}

.certification-badge.endeavor {
  width: 140px;
}

.footer-bottom {
  border-top: 1px solid #E2E8F0;
  padding-top: 24px;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.footer-logo {
  height: 32px;
}

.social-links {
  display: flex;
  gap: 24px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: #7C3AED;
  transition: all 0.2s ease;
  font-size: 20px;
}

.social-link:hover {
  color: #5B21B6;
}

.address {
  font-size: 12px;
  color: #64748B;
  margin: 0;
  font-family: 'Inter', sans-serif;
  line-height: 1.5;
}

@media (max-width: 992px) {
  .footer-links {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .certifications {
    grid-column: span 2;
  }

  .footer-bottom-content {
    flex-direction: column;
    gap: 24px;
  }

  .social-links {
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .footer {
    padding: 32px 16px;
  }

  .footer-links {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  
  .certifications {
    grid-column: auto;
  }
  
  .address {
    text-align: center;
  }
}
</style> 